import Loadable from '@townsquare/loadable';

export const CreateAgentLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "create-agent-view" */ './CreateAgentView'),
	loading: () => null,
});
